import api from './api';

const timeEntryService = {
  // Get all time entries
  getAllTimeEntries: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.employeeId) queryParams.append('employeeId', params.employeeId);
      if (params.projectId) queryParams.append('projectId', params.projectId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.isBillable !== undefined) queryParams.append('isBillable', params.isBillable);

      const queryString = queryParams.toString();
      const url = `/time-entry${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching time entries:', error);
      throw error;
    }
  },

  // Get time entry by ID
  getTimeEntryById: async (id) => {
    try {
      const response = await api.get(`/time-entry/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching time entry:', error);
      throw error;
    }
  },

  // Get next entry number
  getNextEntryNumber: async () => {
    try {
      const response = await api.get('/time-entry/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next entry number:', error);
      throw error;
    }
  },

  // Create time entry
  createTimeEntry: async (timeEntryData) => {
    try {
      const response = await api.post('/time-entry', timeEntryData);
      return response.data;
    } catch (error) {
      console.error('Error creating time entry:', error);
      throw error;
    }
  },

  // Update time entry
  updateTimeEntry: async (id, timeEntryData) => {
    try {
      const response = await api.put(`/time-entry/${id}`, timeEntryData);
      return response.data;
    } catch (error) {
      console.error('Error updating time entry:', error);
      throw error;
    }
  },

  // Delete time entry
  deleteTimeEntry: async (id) => {
    try {
      const response = await api.delete(`/time-entry/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting time entry:', error);
      throw error;
    }
  },

  // Get time entry statistics
  getTimeEntryStats: async () => {
    try {
      const response = await api.get('/time-entry/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching time entry statistics:', error);
      throw error;
    }
  }
};

export default timeEntryService;

